// extracted by mini-css-extract-plugin
export default {"wrapper":"pR-z","availablePromoMessagesLabel":"qR-z","promoMessageList":"rR-z","promoMessage":"sR-z","appliedPromoMessage":"tR-z","promoMessageAmount":"uR-z"};